import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Chip, Checkbox, TextField, Button, Typography } from "@mui/material";
import { toLocalDateInputValue } from "./utils";
import { EmployeeService } from "../../service/employeeService";
import { LocationService } from "../../service/locationService";

export default function DayOverrideDialog({ open, practitionerId: pid, locationId: lid, date, baseSchedule, onSave, onClose }) {
  const [enabled, setEnabled] = useState(!!baseSchedule?.enabled);
  const [start, setStart] = useState(baseSchedule?.start || "09:00");
  const [end, setEnd] = useState(baseSchedule?.end || "17:00");
  const [prName, setPrName] = useState("");
  const [locName, setLocName] = useState("");

  useEffect(() => {
    if (open) {
      setEnabled(!!baseSchedule?.enabled);
      setStart(baseSchedule?.start || "09:00");
      setEnd(baseSchedule?.end || "17:00");
      EmployeeService.getPractitioners().then(res => {
        if (res?.code === 0 && Array.isArray(res.data)) {
          const p = res.data.find(x => x.id === pid);
          setPrName(p?.fullName || `#${pid || ''}`);
        }
      }).catch(() => setPrName(pid ? `#${pid}` : ""));
      LocationService.getLocations().then(res => {
        if (res?.code === 0 && Array.isArray(res.data)) {
          const l = res.data.find(x => x.id === lid);
          setLocName(l?.name || `#${lid || ''}`);
        }
      }).catch(() => setLocName(lid ? `#${lid}` : ""));
    }
  }, [open, baseSchedule, pid, lid]);

  const handleSave = () => {
    onSave({
      pid,
      lid,
      date: toLocalDateInputValue(date),
      override: enabled ? { enabled: true, start, end } : { enabled: false }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Edit This Date Only</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 1 }}>Practitioner: {prName} — Location: {locName}</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Date: {toLocalDateInputValue(date)}</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip size="small" label="Override" sx={{ width: 72 }} />
          <Checkbox checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
          <TextField size="small" label="Start" type="time" value={start} onChange={(e) => setStart(e.target.value)} inputProps={{ step: 1800 }} disabled={!enabled} />
          <TextField size="small" label="End" type="time" value={end} onChange={(e) => setEnd(e.target.value)} inputProps={{ step: 1800 }} disabled={!enabled} />
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          Turn off to make this date unavailable without changing the recurring schedule.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
